module.exports = "<div data-bind=\"text: question.koProgressText, css: question.cssClasses.progressText\"></div>";